
import {Component, Prop} from 'vue-property-decorator';
import {getModule} from "vuex-module-decorators";
import {AppModule, ShopModule, store, TradeInModule} from "@returns-centre/store";
import _ from 'lodash';
import {mixins} from 'vue-class-component';
import {FormatDateMixin} from '@returns-centre/mixins';

@Component
export default class TradeInItemProductList extends mixins(FormatDateMixin) {
    @Prop() tradeInItem!: TradeInItem;
    @Prop({default: false}) showDaysSinceOrder!: boolean;
    @Prop({default: '7rem'}) imageWidth!: string;
    @Prop({default: '7rem'}) imageHeight!: string;

    tradeInModule = getModule(TradeInModule, store);
    shopModule = getModule(ShopModule, store);
    appModule = getModule(AppModule, store);

    getQuantityRange(qty: number) {
        return _.range(qty);
    }

    get imageStyle() {
        return {
            height: this.imageHeight,
            width: this.imageWidth
        }
    }

    get purchasedFromUs() {
        if (!this.tradeInItem.trade_in_product_record) {
            return true;
        }

        return this.tradeInItem.trade_in_product_record.retailer_name === this.shopModule.shop!.shop_domain;
    }
}
